import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout'
import {
  HomePage,
  NewSurveyPage,
  SurveyPage,
  SurveyListPage,
  AdminPage,
  AnalysisResultPage,
  ReviewSurveyPage,
  EditSurveyPage,
  SettingsPage,
  ActivityPage,
  AIPromptsPage
} from './pages'
import { initializeDatabase } from './db/database'
import useCategoryStore from './stores/categoryStore'
import useSettingsStore from './stores/settingsStore'
import { useConnectivity } from './hooks/useConnectivity'
import SyncStatus from './components/SyncStatus'
import PinLock from './components/PinLock'
import './utils/devTools' // Load dev tools for debugging

export default function App() {
  const [isUnlocked, setIsUnlocked] = useState(() => {
    return sessionStorage.getItem('app_unlocked') === 'true'
  })

  const loadCategories = useCategoryStore(state => state.loadCategories)
  const loadSettings = useSettingsStore(state => state.loadSettings)

  // Monitor connectivity and auto-sync
  const { isOnline, pendingUploads, pendingSurveys, syncing, syncingSurveys } = useConnectivity()

  // Initialize app on mount
  useEffect(() => {
    if (!isUnlocked) return

    const init = async () => {
      try {
        // Initialize database with default data
        await initializeDatabase()

        // Load initial data
        await Promise.all([
          loadCategories(),
          loadSettings()
        ])
      } catch (error) {
        console.error('Failed to initialize app:', error)
      }
    }

    init()
  }, [loadCategories, loadSettings, isUnlocked])

  // Show PIN lock if not unlocked
  if (!isUnlocked) {
    return <PinLock onUnlock={() => setIsUnlocked(true)} />
  }

  return (
    <BrowserRouter>
      <Layout>
        <SyncStatus
          isOnline={isOnline}
          pendingUploads={pendingUploads}
          pendingSurveys={pendingSurveys}
          syncing={syncing}
          syncingSurveys={syncingSurveys}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/survey/new" element={<NewSurveyPage />} />
          <Route path="/survey/:id" element={<EditSurveyPage />} />
          <Route path="/survey/:id/photos" element={<SurveyPage />} />
          <Route path="/survey/:id/analysis" element={<AnalysisResultPage />} />
          <Route path="/survey/:id/review" element={<ReviewSurveyPage />} />
          <Route path="/surveys" element={<SurveyListPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/ai-prompts" element={<AIPromptsPage />} />
          <Route path="/activity" element={<ActivityPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}
